@let isMobile = breakpoints() === "mobile";
@if (!isStoreLoaded()) {
  <div class="cls-spacer"></div>
}
@if (isStoreLoaded()) {
  <section>
    @if (isGoogleApiLoaded()) {
      <div class="map">
        @if (stores$ | async; as stores) {
          <app-map
            [features]="stores | getMarkers"
            [forceZoomOnFeature]="forceZoomOnFeature()"
            [style]="{ height: isMobile ? '32rem' : '90rem' }"
            [zoom]="isMobile ? 5 : 6" />
        }
      </div>
      <div class="list">
        <app-store-list />
      </div>
    }
  </section>
}
